<template>
  <div class="footer">
    <!--footer-->
    <div class="page-width">
      <div class="clear">
        <div class="footerGrid footer_left">
          <h4>{{ $t('info') }}</h4>
          <ul>
            <!-- <li>
              <router-link to="/qrCode">Download the app!</router-link>
            </li> -->
            <li>
              <router-link to="/blogs" :style="isSelected1?'font-weight:700':''">{{ $t('blog') }}</router-link>
            </li>
            <li>
              <router-link to="/contact-us" :style="isSelected2?'font-weight:700':''">{{ $t('contact') }}</router-link>
            </li>
            <!-- <li>
              <router-link to="/about-us" :style="isSelected3?'font-weight:700':''">{{ $t('aboutUs') }}</router-link>
            </li> -->
            <li>
              <router-link to="/terms-of-service" :style="isSelected4?'font-weight:700':''">{{ $t('terms') }}</router-link>
            </li>
            <li>
              <router-link to="/privacy" :style="isSelected5?'font-weight:700':''">{{ $t('privacyTitle') }}</router-link>
            </li>
            <!-- <li>
              <router-link to="/faq" :style="isSelected6?'font-weight:700':''">{{ $t('FAQ') }}</router-link>
            </li> -->
            <!-- <li>
              <router-link to="/asian-food">{{ $t('asianFood') }}</router-link>
            </li> -->
          </ul>
        </div>
        <!-- <div class="footerGrid footer_right">
          <h4>{{ $t('keepInTouch') }}</h4>
          <ul class="social-icons" >
            <li>
              <a :href="companyFB" target="_blank">
                <img src="../assets/img/icon_fb_white.png" alt="">
              </a>
            </li>
            <li>
              <a :href="companyGG" target="_blank">
               <img src="../assets/img/icon_google_white.png" alt="">
              </a>
            </li>
            <li>
              <a :href="companyYT" target="_blank">
               <img src="../assets/img/icon_youtube_white.png" alt="">
              </a>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- <div class="app-qrcode">
        <h4>{{ $t('downloadApp') }}</h4>
        <ul>
          <li>
            <img src="../assets/img/app_ios.png" alt="">
            <span>ios</span>
          </li>
          <li>
            <img src="../assets/img/app_android.png" alt="">
            <span>android</span>
          </li>
        </ul>
      </div> -->
    </div>
    <!--end footer-->
    
    <div class="page-width">
      <img src="../assets/img/payment.png" alt="">
    </div>
  </div>
</template>

<script>           
import { Config } from '../../config/default';
import { mapState } from 'vuex'
export default {
  name: "munFooter",
  data() {
    return{
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG,
      companyTT: Config.COMPANY_TT,
      companyGG: Config.COMPANY_GG,
      companyYT: Config.COMPANY_YT,
      isSelected1: false,
      isSelected2: false,
      isSelected3: false,
      isSelected4: false,
      isSelected5: false,
      isSelected6: false,
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn
  }),
  watch: {
    '$route': {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.name === 'blog') {
          this.isSelected1=true
          this.isSelected2=false
          this.isSelected3=false
          this.isSelected4=false
          this.isSelected5=false
          this.isSelected6=false
        }else if (newVal && newVal.name === 'contact') {
          this.isSelected2=true
          this.isSelected1=false
          this.isSelected3=false
          this.isSelected4=false
          this.isSelected5=false
          this.isSelected6=false
        }else if (newVal && newVal.name === 'about') {
          this.isSelected3=true
          this.isSelected1=false
          this.isSelected2=false
          this.isSelected4=false
          this.isSelected5=false
          this.isSelected6=false
        }else if (newVal && newVal.name === 'terms') {
          this.isSelected4=true
          this.isSelected1=false
          this.isSelected2=false
          this.isSelected3=false
          this.isSelected5=false
          this.isSelected6=false
        }else if (newVal && newVal.name === 'privacy') {
          this.isSelected5=true
          this.isSelected1=false
          this.isSelected2=false
          this.isSelected3=false
          this.isSelected4=false
          this.isSelected6=false
        }else if (newVal && newVal.name === 'faq') {
          this.isSelected6=true
          this.isSelected1=false
          this.isSelected2=false
          this.isSelected3=false
          this.isSelected4=false
          this.isSelected5=false
        }else{
          this.isSelected1=false
          this.isSelected2=false
          this.isSelected3=false
          this.isSelected4=false
          this.isSelected5=false
          this.isSelected6=false
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/munFooter.vue